import React from 'react';
import { connect } from 'react-redux';

import withStore from '../../../../withStore';
import { Modal } from '../../../../ui';
import { getShareProviderCallback } from '../../../../shared/providerProfile/reviews/ProviderReviewBuild';

import GetMoreClientsModal from './GetMoreClientsModal';
import { PRO_MANAGE_SERVICES } from '../../../../../route-names';

type Props = {
  close: () => void,
  linkTo: (route: string, params: any) => void,
  providerId: number,
};

const GetMoreClientsModalContainer: React.FC<Props> = ({
  close,
  linkTo,
  providerId,
}) => {
  const props = {
    onPromoteProfileCTAClick: () => {
      close();
      linkTo('responsive.provider.promote', {
        source: 'get_more_clients_modal',
        providerId,
      });
    },
    onAddIGBookButtonCTAClick: () => {
      close();
      linkTo('provider.settings_menu.more', {
        source: 'instagram_book_modal',
        providerId,
      });
    },
    onSendLinkToClientsCTAClick: async () => {
      const shareProvider = await getShareProviderCallback(providerId, '');
      shareProvider();
    },
    onEditServicesCTALink: () => {
      close();
      linkTo(PRO_MANAGE_SERVICES, { providerId });
    },
    close,
  };

  return (
    <Modal appearance="fullScreen">
      <GetMoreClientsModal {...props} />
    </Modal>
  );
};

const mapDispatchToProps = dispatch => ({
  linkTo: (route: string, params: any) => {
    dispatch.route.go({
      route,
      params,
      notify: true,
    });
  },
});

export default withStore(connect(null, mapDispatchToProps)(GetMoreClientsModalContainer));
